/**
 * The newsletter popup's answer, in the shape it has always been stored under
 * `newsletter-modal-answer` (`LEGACY_NEWSLETTER_ANSWER_KEY`): `{ kind, at }`.
 * Pure, so it runs under plain Vitest; `useNewsletterPopup` does the storage.
 */

export type NewsletterAnswerKind = 'dismissed' | 'subscribed'

export interface NewsletterAnswer {
  kind: NewsletterAnswerKind
  at: number
}

/**
 * How long a dismissal buys. Closing the offer is not the same statement as
 * declining it forever — one mistaken click used to cost that visitor the
 * discount permanently. Subscribers are silenced for good instead.
 */
export const NEWSLETTER_DISMISS_TTL_MS = 30 * 24 * 60 * 60 * 1000

/** Anything it does not recognise is no answer at all, so it can never silence the offer by accident. */
export function parseNewsletterAnswer(raw: string | null | undefined): NewsletterAnswer | null {
  if (!raw)
    return null
  try {
    const parsed = JSON.parse(raw) as Partial<NewsletterAnswer> | null
    if (parsed?.kind === 'dismissed' || parsed?.kind === 'subscribed')
      return { kind: parsed.kind, at: Number(parsed.at) || 0 }
  }
  catch {
    // Unparseable — no answer.
  }
  return null
}

/** True while the automatic trap must stay quiet. Opening from the strip ignores this. */
export function newsletterAnswerSilences(answer: NewsletterAnswer | null, now: number): boolean {
  if (!answer)
    return false
  if (answer.kind === 'subscribed')
    return true
  return now - answer.at < NEWSLETTER_DISMISS_TTL_MS
}
